import { Link } from 'react-router-dom';
import '../styles/ValuationEngine/ValuationEngine.css';

export default function ValuationEngineSpotlight() {
  return (
    <section className="ve-spotlight" aria-labelledby="engine-spotlight-title">
      <div className="ve-spotlight-copy">
        <div className="ve-kicker"><span /> Actyra technology</div>
        <h2 id="engine-spotlight-title">One suite. Two insurance worlds. Every valuation step.</h2>
        <p>Explore Actyra’s end-to-end valuation and pricing tool for Life and General Insurance—from product modelling and portfolios to reserving, pricing and reporting.</p>
        <div className="ve-spotlight-actions">
          <Link to="/valuation-engine" className="ve-btn ve-btn-primary">Explore the engine <span>↗</span></Link>
          <Link to="/valuation-engine#book-demo" className="ve-text-link">Book a tailored demo <span>→</span></Link>
        </div>
      </div>
      <div className="ve-mini-console" aria-label="Illustrative valuation run overview">
        <div className="ve-console-bar"><span className="ve-live-dot" /> Illustrative model run <small>Actyra Engine</small></div>
        <div className="ve-console-value"><span>Best estimate liability</span><strong>KES 4.82B</strong><em>+2.4% vs prior</em></div>
        <div className="ve-console-grid">
          <div><span>Data checks</span><strong>48/48</strong></div>
          <div><span>Scenarios</span><strong>12</strong></div>
          <div><span>Runtime</span><strong>03:42</strong></div>
        </div>
        <div className="ve-console-chart"><i /><i /><i /><i /><i /><i /><i /></div>
      </div>
    </section>
  );
}
